import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import {LoanStatusVariant} from '../../../../dtos/EmprestimoDTO';
import {ParcelaStatusVisual} from '../../../../services/creditoMova';

export const LoanCard = styled.View<{warning?: ParcelaStatusVisual | null}>`
  margin: ${RFValue(8)}px 24px 0;
  border-radius: ${RFValue(14)}px;
  border-width: 1px;
  border-color: ${({theme, warning}) => {
    if (warning === 'em_atraso') {return theme.colors.attention;}
    if (warning === 'vence_hoje' || warning === 'a_vencer') {return theme.colors.gold;}
    return theme.colors.border;
  }};
  background-color: ${({theme}) => theme.colors.price_card};
  overflow: hidden;
`;

export const LoanWarningBanner = styled.View<{warning: ParcelaStatusVisual}>`
  flex-direction: row;
  align-items: center;
  padding: ${RFValue(7)}px ${RFValue(12)}px;
  gap: ${RFValue(6)}px;
  background-color: ${({theme, warning}) =>
    warning === 'em_atraso'
      ? theme.colors.attention_opacity
      : theme.colors.gold_opacity};
`;

export const LoanWarningIcon = styled(Feather)<{warning: ParcelaStatusVisual}>`
  font-size: ${RFValue(13)}px;
  color: ${({theme, warning}) =>
    warning === 'em_atraso' ? theme.colors.attention : theme.colors.alert_orange_icon};
`;

export const LoanWarningText = styled.Text<{warning: ParcelaStatusVisual}>`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(11)}px;
  color: ${({theme, warning}) =>
    warning === 'em_atraso'
      ? theme.colors.attention
      : theme.colors.alert_orange_title};
`;

export const LoanHeader = styled.TouchableOpacity`
  padding: ${RFValue(12)}px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const LoanHeaderTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const LoanHeaderDate = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const LoanContent = styled.View`
  border-top-width: 1px;
  border-top-color: ${({theme}) => theme.colors.border};
  padding: ${RFValue(13)}px;
`;

export const LoanStatusPill = styled.View<{variant: LoanStatusVariant}>`
  padding: ${RFValue(4)}px ${RFValue(4)}px;
  border-radius: ${RFValue(6)}px;
  background-color: ${({theme, variant}) => {
    if (variant === 'quitado') {return theme.colors.black;}
    if (variant === 'recusado') {return theme.colors.attention;}
    if (variant === 'analise') {return theme.colors.gold;}
    if (variant === 'aprovado') {return theme.colors.primary;}
    if (variant === 'atrasado') {return theme.colors.attention;}
    if (variant === 'atencao') {return theme.colors.gold;}
    return theme.colors.primary;
  }};
`;

export const LoanStatusText = styled.Text<{variant: LoanStatusVariant}>`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
  color: ${({theme, variant}) =>
    variant === 'pago' || variant === 'quitado'
      ? theme.colors.shape
      : theme.colors.buttonTitle};
`;

export const LoanInfoBlock = styled.View`
  margin-top: 0;
`;

export const LoanInfoRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: ${RFValue(4)}px;
  margin-bottom: ${RFValue(4)}px;
`;

export const LoanInfoLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
`;

export const LoanInfoValue = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const LoanCardAction = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-top: ${RFValue(8)}px;
  padding-top: ${RFValue(8)}px;
  border-top-width: 1px;
  border-top-color: ${({theme}) => theme.colors.border};
`;

export const LoanCardActionText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.loan_action_text};
  margin-right: ${RFValue(4)}px;
`;

export const LoanCardActionIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.loan_action_text};
`;
